import { render, staticRenderFns } from "./JrDesigner.vue?vue&type=template&id=76af9227&"
import script from "./JrDesigner.vue?vue&type=script&lang=js&"
export * from "./JrDesigner.vue?vue&type=script&lang=js&"
import style0 from "./JrDesigner.vue?vue&type=style&index=0&id=76af9227&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JrDesignerBoxArranger: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/BoxArranger.vue').default,JrDesignerAddSectionDialog: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/AddSectionDialog.vue').default,JrDesignerFilePickerDialog: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/FilePickerDialog.vue').default,JrDesignerEditFormDialog: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/EditFormDialog.vue').default,JrDesignerDevPanel: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/DevPanel.vue').default})
